<script>

import {fix, formatTime} from '../../../utils'

export default {
  props: ['setCountSelectValue', 'countSelectValue'],
  data () {
    return {
      // countSelectValue: 0
    }
  },
  computed: {
    transientData () {
      return this.$store.state.transientData
    }
  },
  methods: {
    formatTime,
    fix
  }
}
</script>

<template>
  <div class="pg">
    <!--      功率因数-->
    <div class="dataItems">
      <div class="title">暂升/暂降记录(点击查看详情)</div>
      <div class="dataItem">
        <div class="dataTitle" style="margin: 0 10px; border-bottom: 1px solid #c2c2c2; border-top: 1px solid #c2c2c2; width: calc(100% - 37px); font-weight: 600; color: black;">
          <div class="ItemIndex" style="border-right: 1px solid #c2c2c2">序号</div>
          <div class="ItemLvalue" style="width: 20%; border-right: 1px solid #c2c2c2">发生时刻</div>
          <div class="ItemSvalue" style="border-right: 1px solid #c2c2c2">故障相</div>
          <div class="ItemSvalue" style="width: 20%; border-right: 1px solid #c2c2c2">
            持续时间(ms)
          </div>
          <div class="ItemLvalue">
            <div style="margin: 5px 0">暂降/暂升深度(pu)</div>
            <div class="dataTitleItemLva">
              <div>A</div>
              <div>B</div>
              <div>C</div>
            </div>
          </div>
        </div>
        <div style="overflow: auto; height: calc(100% - 70px)">
          <div class="dataBody" v-for="(item, index) in transientData" :key="index" style="margin: 0 10px; border-bottom: 1px solid #c2c2c2; cursor: pointer;" @click="setCountSelectValue(index)" :style="index===countSelectValue? 'background: #e0e0e0': ''">
            <div class="ItemIndex">{{index + 1}}</div>
            <div class="ItemLvalue" style="width: 20%;">
              <div>{{formatTime(item.sag_time * 1000, 'yyyy/MM/dd')}}</div>
              <div>{{formatTime(item.sag_time * 1000, 'HH:mm:ss')}}</div>
            </div>
            <div class="ItemSvalue">
<!--              <div :class="((item.sag_type>>2) & 1)===1?'lightStyle1':'lightStyle'">-->
<!--                <div :class="((item.sag_type>>2) & 1)===1?'lightItemStyle1':'lightItemStyle'">A</div>-->
<!--              </div>-->
<!--              <div :class="((item.sag_type>>1) & 1)===1?'lightStyle1':'lightStyle'">-->
<!--                <div :class="((item.sag_type>>1) & 1)===1?'lightItemStyle1':'lightItemStyle'">B</div>-->
<!--              </div>-->
<!--              <div :class="(item.sag_type & 1)===1?'lightStyle1':'lightStyle'">-->
<!--                <div :class="(item.sag_type & 1)===1?'lightItemStyle1':'lightItemStyle'">C</div>-->
<!--              </div>-->
              <div v-if="((item.sag_type >> 3) & 1) === 1" style="color: #f40">供电</div>
              <div v-else style="display: flex">
                <div>{{ ((item.sag_type >> 2) & 1) === 1 ? 'A' : '' }}</div>
                <div>{{ ((item.sag_type >> 1) & 1) === 1 ? 'B' : ''}}</div>
                <div>{{ (item.sag_type & 1) === 1 ? 'C' : ''}}</div>
              </div>
            </div>
            <div class="ItemSvalue" style="width: 20%;">
              <div>{{ ((item.sag_type >> 3) & 1) === 1 ? '--' : item.sag_cont_time }}</div>
            </div>
            <div class="ItemLvalue">
              <div class="dataTitleItemLva">
                <div>{{ item.sag_deptha.toFixed(2) }}</div>
                <div>{{ item.sag_depthb.toFixed(2) }}</div>
                <div>{{ item.sag_depthc.toFixed(2) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/transient.css";

.pg{
  height: calc(90vh - 80px);
}

.dataBody{
  height: calc(100%/8);
}
</style>



// WEBPACK FOOTER //
// src/pages/Transient/RfLog/RfLog.vue